<template>
  <div class="page text_center">
    <div
      :class="[
        'header',
        'flex',
        'space_between',
        'align_center',
        ismobile ? 'mobile_header' : '',
      ]"
    >
      <img
        src="../assets/images/logo.png"
        alt=""
        style="width: 180px"
        @click="goBack"
      />
      {{ state.userInfo.nickname }}
    </div>

    <div class="container">
      <div :class="['card', ismobile ? 'mobile_card' : '']">
        <div class="card_header pointer" @click="dialogVisible = true">
          {{ state.currentBook.title ? state.currentBook.title : "请选择词库" }}
          <el-icon color="#fff" class="vertical_middle" :size="20">
            <Switch />
          </el-icon>
        </div>

        <div v-show="state.finsh">
          <img src="../assets/images/finish.png" alt="" style="width: 200px" />
          <br />
          <h2>恭喜！今日任务已完成~</h2>
        </div>

        <div class="word_container" v-if="state.currentWord && !state.finsh">
          <div @click="handleAudio" class="text_right">
            <img
              v-if="!audioShow"
              src="../assets/images/icon3.png"
              alt=""
              width="30"
            /><img
              v-if="audioShow"
              src="../assets/images/icon4.png"
              alt=""
              width="30"
            />
          </div>
          <h4 style="color: #666">
            <div v-if="state.step == 1 || state.step == 2">
              <div class="flex space_around">
                <el-tag>复习</el-tag>
                <span> 总词数：{{ state.old.count }}</span>
                <span>复习完成：{{ state.old.yes }}</span>
              </div>
            </div>

            <div v-if="state.step == 3 || state.step == 4">
              <div class="flex space_around">
                <el-tag type="success">背新词</el-tag>
                <span v-if="state.step == 3">
                  浏览数：{{ state.history_count }}</span
                >
                <span>生词数：{{ state.news.no }}/{{ state.word_set }}</span>
                <span v-if="state.step == 4">完成数：{{ state.news.yes }}</span>
              </div>
            </div>
          </h4>
          <div class="flex align_center space_center">
            <span
              :class="[
                'word',
                ismobile ? 'mobile_word' : '',
                state.wordClasses,
              ]"
            >
              {{ state.currentWord.word }}
            </span>
          </div>

          <div
            :class="[
              'translation',
              ismobile ? 'mobile_translation' : '',
              state.translationClasses,
            ]"
          >
            <div
              v-if="state.showTranslation"
              class="text_center"
              v-for="(item, index) in state.currentWord.means"
              :key="index"
              v-show="index == 0"
              style="padding-left: 10px"
            >
              <span>{{ item.part }} {{ item.means[0] }} </span>
            </div>
          </div>
        </div>

        <div v-if="!state.finsh">
          <div v-if="state.currentBook.id" class="flex space_around">
            <button
              v-if="!state.showQuestionClicked"
              :class="['btn', 'btn_question', ismobile ? 'mobile_btn' : '']"
              @click="showTranslationFunc"
            >
              不熟悉
            </button>
            <button
              v-if="state.showQuestionClicked"
              :class="['btn', 'btn_question', ismobile ? 'mobile_btn' : '']"
              @click="agin"
            >
              重读一遍
            </button>

            <button
              v-if="!state.showQuestionClicked"
              :class="['btn', 'btn_ok', ismobile ? 'mobile_btn' : '']"
              @click="showTranslationAndNext"
            >
              认识的
            </button>
            <button
              v-if="state.showQuestionClicked"
              :class="['btn', 'btn_ok', ismobile ? 'mobile_btn' : '']"
              @click="nextWordAfterTranslation"
            >
              >>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <audio ref="audio"></audio>

  <el-dialog
    v-model="dialogVisible"
    title="请选择词库"
    :width="ismobile ? '90%' : '40%'"
  >
    <div>
      <p
        class="list_item pointer"
        v-for="item in state.list"
        :key="item.id"
        :class="[
          state.currentBook.id == item.id
            ? 'active_bg active_border'
            : item.magic.length > 0
            ? 'active_bg'
            : '',
        ]"
        @click="onSelect(item)"
      >
        {{ item.title
        }}<el-icon
          v-if="state.currentBook.id == item.id"
          class="icon_Promotion vertical_middle"
        >
          <Promotion />
        </el-icon>
      </p>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button color="#6366f9" @click="handleSet"> 开始学习 </el-button>
      </div>
    </template>
  </el-dialog>
  <el-dialog v-model="recordShow" title="学习记录" width="40%">
    <div></div>
  </el-dialog>
  <el-dialog
    v-model="studyShow"
    title="课程安排"
    :width="ismobile ? '90%' : '40%'"
  >
    <div class="text_center word_num">
      <el-button
        @click="countChange(5)"
        :color="state.word_set == 5 ? '#6366f9' : ''"
        >5</el-button
      >
      <el-button
        @click="countChange(10)"
        :color="state.word_set == 10 ? '#6366f9' : ''"
        >10</el-button
      >
      <el-button
        @click="countChange(20)"
        :color="state.word_set == 20 ? '#6366f9' : ''"
        >20</el-button
      >
      <el-button
        @click="countChange(40)"
        :color="state.word_set == 40 ? '#6366f9' : ''"
        >40</el-button
      >
      <el-button
        @click="countChange(50)"
        :color="state.word_set == 50 ? '#6366f9' : ''"
        >50</el-button
      >
      <el-button
        @click="countChange(60)"
        :color="state.word_set == 60 ? '#6366f9' : ''"
        >60</el-button
      >
      <el-button
        @click="countChange(70)"
        :color="state.word_set == 70 ? '#6366f9' : ''"
        >70</el-button
      >
      <el-button
        @click="countChange(80)"
        :color="state.word_set == 80 ? '#6366f9' : ''"
        >80</el-button
      >
      <el-button
        @click="countChange(90)"
        :color="state.word_set == 90 ? '#6366f9' : ''"
        >90</el-button
      >
      <el-button
        @click="countChange(100)"
        :color="state.word_set == 100 ? '#6366f9' : ''"
        >100</el-button
      >
      <br />
      <br />
      <br />
      <div class="flex align_center space_center">
        每天背
        <div class="word_set">{{ state.word_set }}</div>
        个生词
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="studyShow = false">取消</el-button>
        <el-button color="#6366f9" @click="onComfirm"> 确定 </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, toRefs, onMounted } from "vue";
import { ElMessage } from "element-plus";
import "animate.css";
import axios from "axios";
import { post, get } from "../request/post";
import { useRouter } from "vue-router";

const router = useRouter();
const audio = ref();
const dialogVisible = ref(false);
const recordShow = ref(false);
const studyShow = ref(false);
const audioShow = ref(false);
const ismobile = ref(false);

const state = reactive({
  words: [],
  word_set: 40,
  currentWord: null,
  showTranslation: false,
  wordClasses: "",
  translationClasses: "",
  showQuestionClicked: false,
  finsh: false,
  list: [],
  userInfo: {},
  currentBook: {},
  currentClass: {},
  type: 0,
  learnList: [],
  step: 1,
  total: 0,
  page: 1,
  countUnknown: 0,
  old: { yes: 0, no: 0 },
  news: { yes: 0, no: 0 },
  history_count: 0,
});
onMounted(() => {
  init();
  ismobile.value = isMobile();
  function isMobile() {
    let userAgent = navigator.userAgent;
    return /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );
  }

  if (localStorage.getItem("data")) {
    state.userInfo = JSON.parse(localStorage.getItem("data"));
  }
  if (localStorage.getItem("word_set")) {
    state.word_set = localStorage.getItem("word_set");
  }
});

const init = async () => {
  //获取列表
  const { data, code, msg } = await post("/mf/class/index");
  if (code == 200) {
    state.list = data;
    if (localStorage.getItem("current")) {
      let current = JSON.parse(localStorage.getItem("current"));
      state.currentBook = state.list.find((item) => item.id == current.id);
      if (state.currentBook.magic.length > 0) {
        getList(state.currentBook.magic[state.currentBook.magic.length - 1].id);
      } else {
        dialogVisible.value = true;
      }
    }
  } else {
    ElMessage.error(msg);
    return;
  }
};
const getList = async (id) => {
  const { data, code, msg, old, news } = await post("/mf/word/index", {
    task_id: id,
  });
  if (code == 200) {
    state.currentClass = data;
    state.news = news;
    state.old = old;
    if (state.currentClass.is_finish == 2 && state.currentClass.status == 2) {
      state.finsh = true;
      return false;
    }
    state.step = 1;
    // getWordList();
    if (state.currentClass.status == 0 || state.currentClass.status == 1) {
      //复习
      state.step = 1;
      getWordList();
      return false;
    }

    if (state.currentClass.status == 2) {
      //学习新词
      state.type = 1;
      state.step = 3;
      getWordList();
      return false;
    }
  } else {
    ElMessage.error(msg);
    return;
  }
};
// const getRecord = async () => {
//   //获取学习记录
//   recordShow.value = true;
//   const { data, code, msg } = await post("/mf/class/info");
//   if (code == 200) {
//     state.recordList = data;
//   } else {
//     ElMessage.error(msg);
//     return;
//   }
// };

const onComfirm = async () => {
  localStorage.setItem("word_set", state.word_set);
  studyShow.value = false;
  state.learnList = [];
  state.finsh = false;
  state.step = 1;
  state.type = 0;
  state.countUnknown = 0;
  state.old = { yes: 0, no: 0 };
  state.news = { yes: 0, no: 0 };
  state.history_count = 0;
  localStorage.setItem("current", JSON.stringify(state.currentBook));
  const { data, code, msg } = await post("/mf/class/set", {
    class_id: state.currentBook.id,
    num: state.word_set,
  });
  if (code == 200) {
    dialogVisible.value = false;
    getList(data.id);
  } else {
    ElMessage.error(msg);
    return;
  }
};

const getWordList = async () => {
  let url;
  let params = { task_id: state.currentClass.magic_id };
  if (state.step == 1) {
    url = "/mf/word/old";
    params.page = state.page;
  } else {
    url = "/mf/word/new";
  }

  const { data, code, msg, count } = await post(url, params);
  if (code == 200) {
    state.total = count;
    if (data.length == 0 && state.step == 1) {
      state.step = 2;
      state.type = 0;

      getLearn();
    }
    if (data.length == 0 && state.step == 3) {
      state.step = 4;
      state.type = 1;
      getLearn();
    }
    state.words = data;
    if (state.step == 1) {
      state.old.count = state.old.count ? state.old.count : count;
      state.words.forEach((item, index) => {
        if (item.words && item.words.length > 0) {
          item.words.forEach((e) => {
            e.means = JSON.parse(e.means);
            e.audio = `https://ai.netclass.cn/${e.enAudioPath}`;
          });

          state.words[index] = item.words[0];
        }
      });
    } else {
      state.words.forEach((item) => {
        item.means = JSON.parse(item.means);
        item.audio = `https://ai.netclass.cn/${item.enAudioPath}`;
      });
    }
    if (state.words.length > 0) {
      nextWord();
    }
  } else {
    ElMessage.error(msg);
    return;
  }
};

const getLearn = async () => {
  const { data, code, msg, count, news, old, task_nums } = await post(
    "/mf/word/learn",
    {
      id: state.currentClass.id,
      type: state.type,
      // pageSize: 10,
      page: state.page,
    }
  );
  if (code == 200) {
    state.total = count;
    state.news = news;

    state.old = old;
    state.word_set = task_nums;
    if (data.length == 0 && state.step == 2) {
      state.step = 3;
      state.type = 1;
      getWordList();
    }
    if (data.length == 0 && state.step == 4) {
      state.finsh = true;
      return;
    }
    state.words = data;
    state.words.forEach((item, index) => {
      if (item.words && item.words.length > 0) {
        item.words.forEach((e) => {
          e.means = JSON.parse(e.means);
          e.audio = `https://ai.netclass.cn/${e.enAudioPath}`;
          e.id = item.id;
        });

        state.words[index] = item.words[0];
      }
    });
    if (state.words.length > 0) {
      nextWord();
    }
  } else {
    ElMessage.error(msg);
    return;
  }
};
const handleAdd = async () => {
  const { data, code, msg } = await post("/mf/word/add", {
    ids: JSON.stringify(state.learnList),
    task_id: state.currentClass.id,
  });
  state.learnList = [];
  if (code == 200) {
    if (state.step == 2) {
      state.type = 0;
      getLearn();
    }
    if (state.step == 4) {
      state.type = 1;
      getLearn();
    }
  } else {
    ElMessage.error(msg);
    return;
  }
};

const onSubmit = async () => {
  let postData = {
    id: state.currentClass.id,
    ids: JSON.stringify(state.learnList),
  };
  state.learnList = [];
  const { data, code, msg } = await post(
    state.step == 1 ? "/mf/word/sel_old" : "/mf/word/sel",
    postData
  );
  if (code == 200) {
    if (state.step == 1) {
      getWordList();
    }
    if (state.step == 3) {
      getWordList();
    }
  } else {
    if (code == 405 && state.step == 3) {
      //今日已选择N个生词
      state.step = 4;
      state.type = 1;
      getLearn();
    }
    // ElMessage.error(msg);
    return;
  }
};

const onSelect = (item) => {
  state.currentBook = item;
};

const nextWord = () => {
  // console.log(
  //   "step",
  //   state.step,
  //   "total",
  //   state.total,
  //   "learn",
  //   state.learnList
  // );

  if (state.words.length === 0) {
    if (state.step == 1 && state.total > state.learnList.length) {
      // state.page++;
      getWordList();
      return;
    }
    if (state.step == 1 && state.learnList.length >= state.total) {
      onSubmit();
      // getWordList();

      console.log("提交复习数据", state.learnList);
      return;
    }
    if (state.step == 2 && state.learnList.length >= state.total) {
      state.type = 1;
      handleAdd();
      // getLearn();

      console.log("提交复习学习词组数据", state.learnList);
      return;
    }
    if (state.step == 3) {
      console.log("获取新单词列表");
      getWordList();
      return;
    }
    if (state.step == 4 && state.total > state.learnList.length) {
      // state.page++;
      // console.log("获取学习词组", state.page);
      getLearn();
      return;
    }
    if (state.step == 4 && state.learnList.length >= state.total) {
      handleAdd();
      return;
    }
  }
  if (state.words.length > 0) {
    state.currentWord = state.words.shift();
    state.showTranslation = false;
    state.wordClasses = "text_show";
    state.translationClasses = "";
    state.showQuestionClicked = false;
    if (audioShow.value) {
      textToSpeech();
    }
  }
};

const hasUnknown = () => {
  const countUnknown = state.learnList.filter(
    (item) => item.is_know === 0
  ).length;
  state.countUnknown = countUnknown;

  if (state.step == 3 && countUnknown == state.word_set) {
    onSubmit();
    return;
  }
};

const showTranslationFunc = () => {
  let id =
    state.step == 2 || state.step == 4
      ? state.currentWord.id
      : state.currentWord.old_id;
  const exists = state.learnList.some((obj) =>
    Object.values(obj).includes(String(id))
  );
  if (exists) {
    return false;
  }
  if (state.step == 1 || state.step == 2) {
    state.old.no++;
  }
  if (state.step == 3) {
    state.news.no++;
  }

  state.history_count++;

  const itemToPush =
    state.step == 2 || state.step == 4
      ? { is_know: 0, id: state.currentWord.id }
      : { is_know: 0, old_id: state.currentWord.old_id };
  state.learnList.push(itemToPush);
  if (state.step == 3) {
    hasUnknown();
  }
  state.showTranslation = true;
  state.showQuestionClicked = true;
  state.wordClasses = "";
  setTimeout(() => {
    state.wordClasses = "text_show";
  });

  textToSpeech();
};

const showTranslationAndNext = () => {
  let id =
    state.step == 2 || state.step == 4
      ? state.currentWord.id
      : state.currentWord.old_id;
  const exists = state.learnList.some((obj) =>
    Object.values(obj).includes(String(id))
  );
  if (exists) {
    return false;
  }
  if (state.step == 1 || state.step == 2) {
    state.old.yes++;
  }
  if (state.step == 3) {
    state.news.yes++;
  }
  if (state.step == 4) {
    state.news.yes++;
    state.news.no--;
  }
  state.history_count++;

  const itemToPush =
    state.step == 2 || state.step == 4
      ? { is_know: 1, id: state.currentWord.id }
      : { is_know: 1, old_id: state.currentWord.old_id };
  state.learnList.push(itemToPush);

  state.showTranslation = true;
  state.wordClasses = "erasing-text";
  state.translationClasses = "erasing-text";
  setTimeout(() => {
    nextWord();
  }, 1200);
};

const nextWordAfterTranslation = () => {
  state.wordClasses = "erasing-text";
  state.translationClasses = "erasing-text";
  setTimeout(() => {
    state.showTranslation = false;
    nextWord();
  }, 1200);
};

const agin = () => {
  state.showTranslation = true;
  state.wordClasses = " ";
  state.translationClasses = "";
  setTimeout(() => {
    state.wordClasses = "text_show";
  }, 100);
  textToSpeech();
};
const handleAudio = () => {
  audioShow.value = !audioShow.value;
};
const textToSpeech = async () => {
  audio.value.src = state.currentWord.audio;
  audio.value.play();
};
const countChange = (val) => {
  state.word_set = val;
};
const onComfirmCount = () => {
  localStorage.setItem("word_set", state.word_set);
  studyShow.value = false;
  onComfirm();
};
const handleSet = async () => {
  studyShow.value = true;
};
const goBack = () => {
  router.push({ name: "Index" });
};
</script>

<style lang="less" scoped>
.page {
  text-align: center;
  min-height: 100vh;
  h1 {
    margin-top: 0;
  }
}
.header {
  padding: 15px 18%;
  height: 5vh;
}
.mobile_header {
  padding: 15px !important;
}
.container {
  background: #8e93ff;
  height: 95vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card {
  position: relative;
  background-color: #fff;
  border-radius: 20px;
  width: 60%;
  box-shadow: 10px 0 10px 5px #7285fd;
  padding: 20px 15px;
  box-sizing: border-box;
}
/* ///// */
.mobile_card {
  width: 85% !important;
}
.card_header {
  color: #fff;
  font-size: 20px;
  padding-top: 10px;
  background: url("../assets/images/header.png");
  background-size: 100% 100%;
  height: 80px;
  width: 260px;
  position: absolute;
  left: 50%;
  top: -90px;
  transform: translate(-50%);
}

.word {
  font-size: 175px;
  margin-bottom: 15px;
  color: #0f0f0f;
  display: inline-block;
}
.mobile_word {
  font-size: 38px !important;
}

.translation {
  font-size: 50px;
  height: 60px;
}
.mobile_translation {
  font-size: 26px;
}

.btn {
  color: #fff;
  font-size: 32px;
  width: 180px;
  padding: 15px 25px;
  margin: 50px 0;
  border-radius: 35px;
  border: none;
  box-sizing: border-box;
}
.mobile_btn {
  font-size: 20px;
}

.btn_question {
  background-color: #fb6401;
}
.btn_ok {
  background-color: #43cb75;
}

.pointer {
  cursor: pointer;
}

.erasing-text {
  position: relative;
  overflow: hidden;
}

.erasing-text::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 0;
  background-color: #fff;
  animation: eraseText 0.6s linear forwards;
}

@keyframes eraseText {
  to {
    width: 100%;
  }
}

.text_show {
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  display: inline-block;
}

.text_show::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  animation: eraseTexta 1.5s forwards;
}

@keyframes eraseTexta {
  from {
    right: 0%;
  }

  to {
    right: -100%;
  }
}

.word_container {
  /* padding: 20px; */
  box-sizing: border-box;
}

.vertical_middle {
  vertical-align: middle;
}

.active_bg {
  background-color: #edeeff;
  border-radius: 16px;
}
.active_border {
  border: 3px solid #6366f9;
}

.icon_Promotion {
  padding-left: 20px;
}

.list_item {
  padding: 10px;
  margin: 5px 0;
}

.word_set {
  border-radius: 10px;
  padding: 5px 20px;
  margin: 0 5px;
  border: 3px solid #6366f9;
}
.word_num {
  .el-button {
    margin: 10px;
  }
}
</style>
<style>
.el-dialog {
  background: linear-gradient(to bottom, #eaebff 0%, #fff 100%);
  border-radius: 16px;
  padding: 0 50px;
}
</style>
